import Box from "@mui/material/Box";
import { TableCell, TableRow, FormControl, FormLabel, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import "./crud.scss";
import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Brand } from "./Brand";
import { Agency } from "./Agency";
import useBodyClass from "../../../../../hooks/useBodyClass";
import { connect } from 'react-redux';
import { LocalService } from "../../../../../core/services";
import { RolesService } from "../../../../../core/services/roles.service";
import * as gtUtil from "../../../../../core/utility";

import { useNavigate } from 'react-router-dom';
import { AdminPageHead, AdminTabs } from "../components/AdminPageHead";
import { Building2, Store } from "lucide-react";
import { AdminDashboardService } from "../../../../../core/services/admin-dashboard.service";
import { SortingColumnsType, TableComponent } from "../../../../../components/table-component/table";
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import copyAnimation from '../../../../../../src/assets/animations/Copy/copy.json';
import refreshAnimation from '../../../../../../src/assets/animations/Refresh/refresh.json';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import CommonPopUp from "../../../../../components/popup/common-popup";
import { FormValidation } from "../../../../../core/utility";

const rolesService = new RolesService();
const localService: LocalService = new LocalService();
const adminDashboardService = new AdminDashboardService();

const formValidation = new FormValidation();


interface Props {
  UserReducer: any;
}
const Crud: React.FC<Props> = (props: Props) => {
  const lottieRefCopy = useRef<LottieRefCurrentProps>(null);
  const lottieRefRefresh = useRef<LottieRefCurrentProps>(null);
  const [copied, setCopied] = useState(false);

  const [value, setValue] = useState("1");
  const [brandAgency, setBrandAgency] = useState("");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    setSearchList([]);
    setInputValue('');
  };
  const [inputValue, setInputValue] = useState('');
  const [searchList, setSearchList] = useState<any>([]);
  const [renderData, setRenderData] = useState<any>([]);
  const [masterKey, setMasterKey] = useState<string>('');

  // Influencer Offer Subscription logic
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openPremiumDetails, setOpenPremiumDetails] = useState(false);
  const [delete_remark_popup, set_delete_remark_popup] = useState(false);
  const [formError, setFormErrors] = useState({
    remark: { status: true, message: '' },
    remarkDescription: { status: true, message: '' },
  });
  const [remark, setRemark] = useState('');
  const [selectedInfluencer, setSelectedInfluencer] = useState<any>();
  
  const [isContinueDeleteDisabled, setIsContinueDeleteDisabled] = useState(true);
  const [otherRemark, setOtherRemark] = useState(false);
  const [remarkDescription, setRemarkDescription] = useState("");

  const onSelectChange = async (data: any) => {
    try {
      // setIsContinueDisabled(false)
      setIsContinueDeleteDisabled(false);
      setRemark(data);
      if (data == "Other") {
        setOtherRemark(true);
      } else {
        setOtherRemark(false);
        setRemarkDescription("");
      }
    } catch (error) {
      console.log(`onSelectChange error :: ${JSON.stringify(error)}`);
    }
  };

  const handleRemarkDescription = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = (event.target as HTMLInputElement).value;
    setRemarkDescription(selectedValue);
    const isValidRemarkDescription =
      formValidation.GetNameValidate(selectedValue).status;

    if (remark === "Other" && !isValidRemarkDescription) {
      setFormErrors((prev) => ({
        ...prev,
        remarkDescription: { status: false, message: "This Field is required" },
      }));
      // return;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        remarkDescription: { status: true, message: "" },
      }));
    }
    // setFormData({ ...formData, reason: (event.target as HTMLInputElement).value });
    // validateForm();
  };

  const handleClose = (value: boolean) =>{
    setOpenConfirm(false);
    setOpenPremiumDetails(false);
    set_delete_remark_popup(false);
    setFormErrors({
      ...formError,
      remark: {
        status: true,
        message: ''
      },
    });
    setRemark('');
    setRemarkDescription("");
    setIsContinueDeleteDisabled(true);
    setOtherRemark(value);
  }

  const handleError = (event: any) => {
    const validateRemark = formValidation.GetNameValidate(remark);
    setFormErrors({
      ...formError,
      remark: validateRemark,
    });
  };

  const handlePremium = async (e: any) => {
    try {
      e.preventDefault();
      const validateRemark = formValidation.GetNameValidate(remark);
      setFormErrors({
        ...formError,
        remark: validateRemark,
      });
      if (validateRemark.status) {
        try {
          const response = await adminDashboardService.handleInfluencerOfferPremium({
            account_id : selectedInfluencer.account_id,
            user_id : selectedInfluencer.user_id,
            influencer_id : selectedInfluencer.influencer_id,
            email_primary : selectedInfluencer.email_primary,
            mobile_whatsapp : selectedInfluencer.mobile_whatsapp,
            remark : remark,
            subscribed_by : props.UserReducer.user_id,
          });            
          if (response.data.status.status) {
            localService.toastify(response.data.status.message, 'success', 1000);
          } else {
            localService.toastify(response.data.status.message, 'error', 1000);
          }
        } catch (error) {
          console.log(
            'handlePremium Error :: ',
            JSON.stringify(error)
          );
        }
        handleClose(false);
      }
    } catch (error) {
      console.log('handlePremium Error :: ', JSON.stringify(error));
      handleClose(false);
    }
  };

  const navigate = useNavigate();

  const onClickFunction = (value: string) => {
    setBrandAgency(value);
  };
  useBodyClass('crud-page');
  useEffect(() => {
    // CHECK IF USER ALLOWED  ACCESS 
    checkAccessFunction();
    handleRefresh();
  }, []);

  const checkAccessFunction = async () => {
    try {
      const res = await rolesService.checkOrAccess({ access_roles: ["view_admin_dashboard", "create_user", "delete_user", "view_master_key"], user_id: props?.UserReducer?.user_id })
      if (res.data.rows.length > 0) {
        // Function call if required
      }
      else {
        localService.toastify("You are not allowed to access", "error", 1000);
        navigate(`/`);
      }
    }
    catch (error) {
      console.error('Error fetching getAdminDashData:', error);
    }
  }

  const columnDisplayName = {
    full_name: "Name (acc_id)",
    login_mobile: "Mobile (user_id)",
    login_email: "Email (user_id)",
    acc_type: "Account Type",
    username: "Instagram Handle Name (ig_id)",
    title: "YouTube Channel Name (yt_id)",
    action: "Action"
  };

  const sortingColumnType: SortingColumnsType[] = [
    {
      name: "full_name",
      columnSize: "200px",
    },
    {
      name: "login_mobile",
      columnSize: "140px",
    },
    {
      name: "login_email",
      columnSize: "200px",
    },
    {
      name: "acc_type",
      columnSize: "100px",
    },
    {
      name: "username",
      columnSize: "200px",
    },
    {
      name: "title",
      columnSize: "200px",
    },
    {
      name: "action",
      columnSize: "100px",
    },

  ];

  //Search the user function
  const handleSearchUser = async (loginEmailMobile: string) => {
    try {
      const response = await adminDashboardService.getUserDetail(loginEmailMobile);
      if (response.data.status) {
        setSearchList(response.data.rows);
      }
    } catch (error) {
      console.log(`handleSearchUser error :: ${JSON.stringify(error)}`);
    }
  };

  //Search the user function
  const handleSearchUserByUsername = async (username: string) => {
    try {
      const response = await adminDashboardService.getInfluencerDetail(username);
      if (response.data.status) {
        setSearchList(response.data.rows);
      }
    } catch (error) {
      console.log(`handleSearchUser error :: ${JSON.stringify(error)}`);
    }
  };

  //Delete the user function
  const deleteUser = async (loginEmailMobile: string, accountType: string, userId?: number) => {
    let response;
    setIsContinueDeleteDisabled(true);
    try {
      const validateRemark = formValidation.GetNameValidate(remark);
      setFormErrors({
        ...formError,
        remark: validateRemark,
      });
      if (validateRemark.status) {
        // if (accountType === 'Influencer') {
        //   response = await adminDashboardService.deleteInfluencer({ login: loginEmailMobile, remark: remark, remark_description: remarkDescription, done_by: props.UserReducer.user_id, deleted_from_platform: "web"});
        //   if (response.status === gtUtil.Constants.SUCCESS) {
        //     localService.toastify(response.info)
        //     setInputValue('');
        //     setSearchList([]);
        //   } else {
        //     // localService.toastify(response.info)
        //   }
        // }
        // if (accountType === 'Brand') {
        //   response = await adminDashboardService.deleteBrand({ login: loginEmailMobile, remark: remark, remark_description: remarkDescription, done_by: props.UserReducer.user_id, deleted_from_platform: "web" });
        //   if (response.status === gtUtil.Constants.SUCCESS) {
        //     localService.toastify(response.info)
        //     setInputValue('');
        //     setSearchList([]);
        //   } else {
        //     // localService.toastify(response.info)
        //   }
        // }
        // if (accountType === 'Agency') {
        //   response = await adminDashboardService.deleteAgency({ login: loginEmailMobile, remark: remark, remark_description: remarkDescription, done_by: props.UserReducer.user_id, deleted_from_platform: "web" });
        //   if (response.status === gtUtil.Constants.SUCCESS) {
        //     localService.toastify(response.info)
        //     setInputValue('');
        //     setSearchList([]);
        //   } else {
        //     // localService.toastify(response.info)

        //   }
        // }
        // if (accountType === 'Talent Partner') {
        //   response = await adminDashboardService.deleteTalentPartner({ login: loginEmailMobile, remark: remark, remark_description: remarkDescription, done_by: props.UserReducer.user_id, deleted_from_platform: "web"});
        //   if (response.status === gtUtil.Constants.SUCCESS) {
        //     localService.toastify(response.info)
        //     setInputValue('');
        //     setSearchList([]);
        //   } else {
        //     // localService.toastify(response.info)
        //   }
        // }
        response = await adminDashboardService.softDeleteUser({ user_id: userId, login: loginEmailMobile, type: accountType, remark: remark, remark_description: remarkDescription, done_by: props.UserReducer.user_id, deleted_from_platform: "web"});
        if (response.status === gtUtil.Constants.SUCCESS) {
          localService.toastify(response.info, 'success', 1000);
          setInputValue('');
          setSearchList([]);
        } else {
          localService.toastify(response.info, 'error', 1000);
        }
      }
    } catch (error) {
      console.log(`deleteUser error :: ${JSON.stringify(error)}`);
    } finally {
      handleClose(false);
      setIsContinueDeleteDisabled(false);
    }
  }

  const handleCopy = () => {
    // Reset and play copy animation
    lottieRefCopy.current?.stop();
    lottieRefCopy.current?.play();
    navigator.clipboard.writeText(masterKey);
    setCopied(true);
    
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRefresh = async () => {
    // Reset and play refresh animation
    lottieRefRefresh.current?.stop();
    lottieRefRefresh.current?.play();
    const response = await adminDashboardService.getMasterKey();
    if (response.status === gtUtil.Constants.SUCCESS) {
      setMasterKey(response.data.rows[0].value || '');
    }
  }

  useEffect(() => {
    if (otherRemark && (remarkDescription.trim() !== "" && remarkDescription.length > 2)) {
      // setIsContinueDisabled(false);
      setIsContinueDeleteDisabled(false);

    } else if (!otherRemark && remark) {
      // setIsContinueDisabled(false);
      setIsContinueDeleteDisabled(false);
    } else {
      // setIsContinueDisabled(true);
      setIsContinueDeleteDisabled(true);
    }
  }, [otherRemark, remarkDescription, remark]);

  return (
    <div className="adminDashboardCrudMostOutterDiv">
      <div className="adminDashboardCrudContentOutterDiv px-0">
        <div className="adminDashboardCrudContentDiv">
          <AdminPageHead title="Crud" subtitle="Create brand and agency accounts, delete users, and manage keys and free subscriptions." />
          <div className="adminDashboardCrudToggleButtonsDiv">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <AdminTabs
                  current={value}
                  onChange={(v) => {
                    if (v === "1") setBrandAgency("");
                    handleChange({} as React.SyntheticEvent, v);
                  }}
                  tabs={[
                    { value: "1", label: "Create User" },
                    ...(props.UserReducer?.delete_user == "True" ? [{ value: "2", label: "Delete User" }] : []),
                    ...(props.UserReducer?.view_master_key == "True" ? [{ value: "3", label: "Random String" }] : []),
                    ...(props.UserReducer?.delete_user == "True" ? [{ value: "4", label: "Provide Free Influencer Subscription" }] : []),
                  ]}
                />

                <TabPanel value="1" style={{ padding: "0" }}>
                  <div className="createUserDiv">
                    {brandAgency.length === 0 ? (
                      <div className="brd-admin-card">
                        <h2 className="brd-admin-card__title">Create a user</h2>
                        <p className="brd-admin-card__sub">Pick the kind of account to create.</p>
                        <div className="brd-admin-choice">
                          <button type="button" className="brd-admin-choice__item" onClick={() => onClickFunction("brand")}>
                            <span className="brd-admin-choice__icon"><Store size={20} /></span>
                            <span className="brd-admin-choice__title">Brand</span>
                            <span className="brd-admin-choice__body">A single brand's account.</span>
                          </button>
                          <button type="button" className="brd-admin-choice__item" onClick={() => onClickFunction("agency")}>
                            <span className="brd-admin-choice__icon"><Building2 size={20} /></span>
                            <span className="brd-admin-choice__title">Agency</span>
                            <span className="brd-admin-choice__body">An agency that runs several brands.</span>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {brandAgency === "brand" ? <Brand setBrandAgency={setBrandAgency} /> : <Agency setBrandAgency={setBrandAgency} />}
                      </div>
                    )}
                  </div>
                </TabPanel>
                {/* 
                {(() => {
                  if (props.UserReducer?.create_user == "True") {
                    return (
                      <Tab
                        className='tab-underline-menu'
                        label='Crud'
                        value='crud'
                      />)
                  }
                })()} */}
                <TabPanel value="2" style={{ padding: "0" }}>
                  <div className="brd-admin-card">
                    <h2 className="brd-admin-card__title">Delete User</h2>
                    <p className="brd-admin-card__sub">Find the account by its email id or phone number.</p>
                    <div className="brd-admin-inline">
                      <TextField
                        id="outlined-basic"
                        label="Enter Email Id / Phone Number"
                        variant="outlined"
                        size="small"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      <Button
                        variant='contained'
                        onClick={() => handleSearchUser(inputValue)}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value="3" style={{ padding: "0" }}>
                  <div className="brd-admin-card">
                    <h2 className="brd-admin-card__title">Random String</h2>
                    <p className="brd-admin-card__sub">Copy the current master key, or refresh it.</p>
                    <span className="buttonsSpan">
                      <Button
                        className="btn btn-outline-primary btn-mui me-2 "
                        // onClick={() => {
                        //   onClickFunction("brand");
                        // }}
                      >
                        <Tooltip title={copied ? 'Copied!' : 'Copy'}>
                          <IconButton 
                            className="mb-2"
                            onClick={handleCopy} 
                            size="small">
                            <Lottie
                              lottieRef={lottieRefCopy}
                              animationData={copyAnimation}
                              style={{ width: 24, height: 24 }}
                              autoplay={false}
                              loop={false}
                            />
                          </IconButton>
                        </Tooltip>
                        {masterKey}
                      </Button>
                      <Tooltip title="Refresh">
                        <IconButton 
                          className="mb-2"
                          onClick={handleRefresh} 
                          size="small">
                          <Lottie
                            lottieRef={lottieRefRefresh}
                            animationData={refreshAnimation}
                            style={{ width: 24, height: 24 }}
                            autoplay={false}
                            loop={false}
                          />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </div>
                </TabPanel>

                <TabPanel value="4" style={{ padding: "0" }}>
                  <div className="brd-admin-card">
                    <h2 className="brd-admin-card__title">Provide Free Influencer Subscription</h2>
                    <p className="brd-admin-card__sub">Find the creator by their username.</p>
                    <div className="brd-admin-inline">
                      <TextField
                        id="outlined-basic"
                        label="Username"
                        variant="outlined"
                        size="small"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      <Button
                        variant='contained'
                        onClick={() => handleSearchUserByUsername(inputValue)}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </TabPanel>
              </TabContext>

              {
                ['2','4'].includes(value) && 
                <div className="row col-12 mt-4">
                  <TableComponent
                    pagination={false}
                    columnDisplayName={columnDisplayName}
                    sortingColumnType={sortingColumnType}
                    inputDataSource={searchList}
                    orderByColumnName=""
                    renderData={renderData}
                    setRenderData={setRenderData}
                  >
                    {renderData.map((data: any, index: number) => {
                      return (
                        <TableRow key={index} >
                          <TableCell>{data.full_name} {data.account_id ? `(${data.account_id})` : ''}</TableCell>
                          <TableCell>{data.login_mobile} {data.user_id ? `(${data.user_id})` : ''}</TableCell>
                          <TableCell>{data.login_email} {data.user_id ? `(${data.user_id})` : ''}</TableCell>
                          <TableCell>{data.acc_type}</TableCell>
                          <TableCell>{data.username} {data.ig_id ? `(${data.ig_id})` : ''}</TableCell>
                          <TableCell>{data.title} {data.yt_id ? `(${data.yt_id})` : ''}</TableCell>
                          {/* <TableCell><Button onClick={() => [data.account_id, data.acc_type]}>Delete</Button></TableCell> */}
                          <TableCell>
                            {
                              value === '4' && data.acc_type === 'Influencer'
                              ?
                              <Button
                                variant='contained'
                                className='btn btn-primary me-2'
                                onClick={() => {
                                  setSelectedInfluencer(data);
                                  setOpenConfirm(true);
                                }}>
                                Provide Subscription
                              </Button>
                              :
                              <Button
                                variant='contained'
                                className='btn btn-primary'
                                onClick={() => {
                                  setSelectedInfluencer(data);
                                  set_delete_remark_popup(true);
                                }}>
                                Delete
                              </Button>
                            }
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableComponent>
                </div>
              }
            </Box>
          </div>
        </div>
      </div>

      {delete_remark_popup && (
        <CommonPopUp
          modalTitle={'Delete User'}
          openModal={delete_remark_popup}
          onClose={() => handleClose(false)}
          className="modal-medium mx-auto"
        >
          <div className="deactivate-popup">
            <div>
              <FormControl fullWidth size="small" className="mt-2">
                {formError.remark.message && (
                  <div style={{ color: "red", marginTop: "8px" }}>
                    {formError.remark.message}
                  </div>
                )}
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Other"
                  name="radio-buttons-group"
                  id="gender_id"
                  value={remark}
                  onChange={(e) => {
                    onSelectChange(e.target.value);
                  }}
                  className="deactivate-popup-input-sec"
                >
                  <FormControlLabel className="mb-2"
                    value="I’m concerned about privacy and data security"
                    control={<Radio className="py-0" size="small" />}
                    label="I’m concerned about privacy and data security."
                  />
                  <FormControlLabel className="mb-2"
                    value="I've moved to another platform"
                    control={<Radio className="py-0" size="small" />}
                    label="I've moved to another platform."
                  />
                  <FormControlLabel className="mb-2"
                    value="I no longer want to use the platform"
                    control={<Radio className="py-0" size="small" />}
                    label="I no longer want to use the platform."
                  />
                  <FormControlLabel className="mb-2"
                    value="The platform doesn't meet my expectations"
                    control={<Radio className="py-0" size="small" />}
                    label="The platform doesn't meet my expectations."
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio className="py-0" size="small" />}
                    label="Other"
                    onClick={() => setOtherRemark(true)}
                  />
                  {otherRemark && (
                    <div className="mt-2">
                      <TextField
                        className="w-100"
                        id="remarkDescription"
                        name="remarkDescription"
                        multiline
                        rows={4}
                        value={remarkDescription}
                        error={!formError.remarkDescription.status}
                        helperText={formError.remarkDescription.message}
                        onChange={handleRemarkDescription}
                        onBlur={() => {
                          setFormErrors({
                            ...formError,
                            remarkDescription:
                              formValidation.GetNameValidate(remarkDescription),
                          });
                        }}
                      />
                      {/* {formError.remarkDescription.message && <div style={{ color: 'red', marginTop: '8px' }}>{formError.remarkDescription.message}</div>} */}
                    </div>
                  )}
                </RadioGroup>
              </FormControl>
              <div className="popup-footer">
                <div className="d-flex justify-content-end">
                  <Button
                    className="btn btn-primary btn-mui  ms-2"
                    onClick={() => {
                      deleteUser(String(selectedInfluencer.login_mobile), String(selectedInfluencer.acc_type), Number(selectedInfluencer.user_id) || undefined);
                    }}
                    variant="outlined"
                    disabled={isContinueDeleteDisabled}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="mt-2">
            <TextField
              fullWidth
              label='Remark'
              name='remark'
              variant='standard'
              value={remark}
              error={!formError?.remark?.status}
              helperText={formError?.remark?.message}
              onChange={(e) =>
              setRemark(e.target.value)
              }   
              onBlur={handleError}
            />
            <div className='col-lg-auto text-end mt-3 mb-3'>
              <Button
                size='small'
                type="submit"
                className="btn btn-primary"
                variant="outlined"
                onClick={() => {
                  deleteUser(String(selectedInfluencer.login_mobile), String(selectedInfluencer.acc_type), Number(selectedInfluencer.user_id) || undefined);
                }}
              >
                Confirm
              </Button>
            </div>
          </div> */}
        </CommonPopUp>
      )}

      {openConfirm && (
        <CommonPopUp
          modalTitle={'Premium'}
          openModal={openConfirm}
          onClose={() => handleClose(false)}
          className="modal-medium mx-auto"
        >  
          <div>
            <p>Are you sure you want to give 1 month offer subscription to user "{selectedInfluencer?.name}" ?</p>
            <form onSubmit={handlePremium}>
              <TextField
                fullWidth
                label='Remark'
                name='remark'
                variant='standard'
                value={remark}
                error={!formError?.remark?.status}
                helperText={formError?.remark?.message}
                onChange={(e) =>
                setRemark(e.target.value)
                }   
                onBlur={handleError}
              />
              <div className='col-lg-auto text-end mt-3 mb-3'>
                <Button
                  size='small'
                  type="submit"
                  className="btn btn-primary"
                  variant="outlined"
                >
                  Confirm
                </Button>
              </div>
            </form>
          </div>   
        </CommonPopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const connectToRedux = connect(
  mapStateToProps
)(Crud);

export { connectToRedux as Crud };
